import { useRef, useState, useEffect, lazy, Suspense } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import Navbar from './components/Navbar';

// Lazy-load all below-the-fold sections
const HowItWorks   = lazy(() => import('./components/HowItWorks'));
const About        = lazy(() => import('./components/About'));
const WhyChooseUs  = lazy(() => import('./components/WhyChooseUs'));
const Emergency    = lazy(() => import('./components/Emergency'));
const ServiceAreas = lazy(() => import('./components/ServiceAreas'));
const Testimonials = lazy(() => import('./components/Testimonials'));
const FAQ          = lazy(() => import('./components/FAQ'));
const Contact      = lazy(() => import('./components/Contact'));
const Footer       = lazy(() => import('./components/Footer'));

function LazySection({ children }: { children: React.ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref}>
      {visible ? (
        <Suspense fallback={<div className="h-32" />}>
          {children}
        </Suspense>
      ) : (
        <div className="h-32" />
      )}
    </div>
  );
}

export default function HomePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <LazySection><HowItWorks /></LazySection>
        <LazySection><About /></LazySection>
        <LazySection><WhyChooseUs /></LazySection>
        <LazySection><Emergency /></LazySection>
        <LazySection><ServiceAreas /></LazySection>
        <LazySection><Testimonials /></LazySection>
        <LazySection><FAQ /></LazySection>
        <LazySection><Contact /></LazySection>
      </main>
      <LazySection><Footer /></LazySection>
    </div>
  );
}
